<div class="results-container"
     #widthElement>
  <div #chartElement>
    <ngx-charts-bar-vertical-2d *ngIf="plotFramework === 'ngx' && graphType==='bargroup'"
                                [view]="view"
                                [scheme]="colorScheme"
                                [results]="graphData"
                                [gradient]="gradient"
                                [legend]="true"
                                [legendPosition]="'below'"
                                [xAxis]="showXAxis"
                                [yAxis]="showYAxis"
                                [showXAxisLabel]="showXAxisLabel"
                                [showYAxisLabel]="showYAxisLabel"
                                [xAxisLabel]="xAxisLabel"
                                [yAxisLabel]="yAxisLabel"
                                [xAxisTickFormatting]="boundTickFormatting"
    >
    </ngx-charts-bar-vertical-2d>
    <ngx-charts-bar-vertical *ngIf="plotFramework === 'ngx' && graphType==='bar'"
                             [view]="view"
                             [scheme]="colorScheme"
                             [results]="graphData"
                             [gradient]="gradient"
                             [xAxis]="showXAxis"
                             [yAxis]="showYAxis"
                             [showXAxisLabel]="showXAxisLabel"
                             [showYAxisLabel]="showYAxisLabel"
                             [xAxisLabel]="xAxisLabel"
                             [yAxisLabel]="yAxisLabel"
                             [xAxisTickFormatting]="boundTickFormatting"
    >
    </ngx-charts-bar-vertical>
    <app-plotly *ngIf="plotFramework === 'plotly'" #plotlyComponent
                [graphType]="graphType"
                [graphData]="graphData"
                [view]="view"
                [layout]="customLayout"
                [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel"
                [precision]="precision"
                [legend]="plotlyLegend"
    ></app-plotly>
  </div>
</div>
<div *ngIf="graphData && !hideSaveButtons"
     class="results-container media-button-container">
  <button [id]="getPrefixedId('saveToPc_button')"
          class="btn-green save-media-button"
          mat-button
          (click)="openDialog(false)"
  >{{'RESULTS.GENERAL.SAVE_GRAPH_TO_PC' | anessaTranslation: trigger}}
  </button>
  <canvas #graphCanvas
          style="display:none">

  </canvas>
</div>
